import { getSections } from "features/service/selectors";
import { createSelector } from "reselect";

export const getSectionOptions = createSelector(getSections, (sections) =>
    sections?.map((data) => ({
        label: data.displayName,
        value: data.id,
    }))
);
